import local from './local'
import apothem from './apothem'
import xinfin from './xinfin'

export default {
  local,
  apothem,
  xinfin,
}
